export interface ApiToken {
    id: string;
    name: string;
    tokenPrefix: string;
    roles: string[];
    expiresAt: string | null;
    lastUsedAt: string | null;
    createdAt: string;
}

export interface ApiTokenCreateResponse extends ApiToken {
    token: string;
}

export interface CreateApiTokenDto {
    name: string;
    expiresAt?: string;
}
